/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PaymentRedirectToOrderConfirmation Input Action
 */
export class PaymentRedirectToOrderConfirmationInput implements Msdyn365.IActionInput {
    //   Construct the input needed to run the action
    constructor() {}

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `PaymentRedirectToOrderConfirmation`;
    public getCacheObjectType = () => 'PaymentRedirectToOrderConfirmation';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

//   Create a data model here or import one to capture the response of the action
export interface IPaymentRedirectToOrderConfirmationData {
    redirectToOrderConfirmation: boolean;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PaymentRedirectToOrderConfirmationInput();
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function paymentRedirectAction(input: PaymentRedirectToOrderConfirmationInput, ctx: Msdyn365.IActionContext): Promise<IPaymentRedirectToOrderConfirmationData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    //   Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IPaymentRedirectToOrderConfirmationData[]>('/get/example/id/1', 'get');
    return { redirectToOrderConfirmation: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPaymentRedirectToOrderConfirmationData>>paymentRedirectAction,
    //   Give your data action a unique id
    id: 'PaymentRedirectToOrderConfirmation',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
